import { customToFixed, customToFixedPretty } from './custom-to-fixed';

const dataUnits = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

export const DataUnitsTransform = (value: number, startUnitIndex = 0, decimals = 0, maxLength?: number): string => {
  for (let i = 0; i < startUnitIndex; i++) value *= getMultiplicationValue(i);
  if (!value) value = 0;
  const type = DataUnitsgetUnitType(value);
  const newVal = DataUnitsCalc(value, type);

  if (maxLength) return customToFixedPretty(newVal, maxLength) + ' ' + type;
  return customToFixed(newVal, decimals) + ' ' + type;
};

export const DataUnitsCalc = (value: number | string, type: string, base = 0): number => {
  if (typeof value === 'string') value = parseFloat(value);
  const unitIndex = dataUnits.indexOf(type);
  for (let i = base; i < unitIndex; i++) value /= getMultiplicationValue(i);
  return value;
};

export const DataUnitsgetUnitType = (value: number, unitIndex = 0) => {
  if (value === 0) return dataUnits[2];
  while (Math.abs(value) >= getMultiplicationValue(unitIndex)) {
    unitIndex += 1;
    value /= getMultiplicationValue(unitIndex);
  }
  return dataUnits[unitIndex];
};

export const DataUnitsAsString = (value: number) => {
  if (!value) value = 0;
  const array = value.toFixed(2).split('');
  while (array.slice().pop() === '0') array.pop();
  if (array.slice().pop() === '.') array.pop();
  return array.join('');
};

const getMultiplicationValue = (unitIndex: number) => {
  return dataUnits[unitIndex] === 'GB' ? 1000 : 1024;
};
